import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getInvoicePendingCountReport } from "../../services/pendinginvoice.services";

// Async Thunk for fetching the invoice pending count report
export const fetchInvoicePendingCountReport = createAsyncThunk(
  "invoicePendingReport/fetchInvoicePendingCountReport",
  async (groupBy, { rejectWithValue }) => {
    try {
      const data = await getInvoicePendingCountReport(groupBy);
      return data; // Return the data from the API response
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const invoicePendingCountSlice = createSlice({
  name: "invoicePendingReport",
  initialState: {
    data: null, // Holds the invoice report data
    status: "idle", // idle | loading | succeeded | failed
    error: null, // Holds error messages
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvoicePendingCountReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchInvoicePendingCountReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload; // Store the invoice pending report data
      })
      .addCase(fetchInvoicePendingCountReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload; // Store error message
      });
  },
});

export default invoicePendingCountSlice.reducer;
